import { Permissions } from '@/domain/authenticating/authentication/presentation/UserProfilePresentation'
import { injectable } from 'inversify'

@injectable()
export class HasRequiredPermissionsUseCase {
  constructor(
    private readonly permissions: string[],
  ) {
  }

  public execute(userPermissions: Permissions, organizationId: string): boolean {
    const organizationPermissions = userPermissions[organizationId] ?? []

    return organizationPermissions.some((userPermission) =>
      this.permissions.some(permission =>
        permission.toLowerCase() === userPermission.toLowerCase(),
      ),
    )
  }
}
